import { gql } from 'graphql-tag';

export const GET_PAYABLES_TO_PREPARE_COUNTS = gql`
  query Id1b977e5f0ad5be902fa48ac078ae514b(
    $companyId: ID!
    $prepareFilters: JSON
  ) {
    __typename
  }
`;
